module.exports = __webpack_public_path__ + "img/icon-arrow.cdaf0d6a.svg";